<table mat-table [dataSource]="rowsDefinition" *ngIf="plans">

  <!--  First, static header with column definition (plan features description)-->
  <ng-container [matColumnDef]="KEY_FEATURES_COLUMN_HEADER">
    <th mat-header-cell class="first-column-width" *matHeaderCellDef [attr.colspan]="fullWidthStaticHeader ? plans.length + 1 : 1">
      <ng-content select="[table][staticHeader]"></ng-content>
    </th>
    <td mat-cell *matCellDef="let rowDefinition" class="feature-description">
      <div class="plan-feature">
        {{rowDefinition['translateKey'] | translate}}
      </div>
      <span *ngIf="rowDefinition['soon']" translate class="soon">
        SOON
      </span>
      <mat-icon
        class="text-xs gray-text pointer"
        *ngIf="rowDefinition['tooltipText'] | translate"
        [matTooltip]="rowDefinition['tooltipText'] | translate">help_outline
      </mat-icon>
    </td>
  </ng-container>

  <!--  Columns with individual plans. Header is added dynamically through ng-template with 'column' param -->
  <ng-container [matColumnDef]="column.plan.id" *ngFor="let column of planColumns">
    <th mat-header-cell *matHeaderCellDef
        [ngStyle]="{'display': fullWidthStaticHeader ? 'none': 'table-cell'}"
        class="column-fixed-width"
        [class.most-popular]="column.plan.mostPopular"
    >
      <ng-template [ngTemplateOutlet]="planHeaderRef" [ngTemplateOutletContext]="{$implicit: column}"></ng-template>
    </th>

    <td mat-cell *matCellDef="let rowDefinition"
        class="column-fixed-width"
        [class.most-popular]="column.plan.mostPopular"
    >
      <ng-container *ngIf="rowDefinition['cellValue'](column.plan) as cellValue; else noValue">
        <img src="/assets/img/channels/check.svg" *ngIf="cellValue.check"/>
        <span *ngIf="cellValue !== 'CHECK'">
          {{cellValue.text | translate: { from: cellValue.from, to: cellValue.to } }}
        </span>
      </ng-container>
      <ng-template #noValue>
        <img src="/assets/img/channels/x.svg"/>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="planColumnHeaders"></tr>
  <tr mat-row *matRowDef="let row; columns: planColumnHeaders;"></tr>
</table>
